import React from 'react';
import PropTypes from 'prop-types';
import { FormattedText, formatText } from 'core/i18n';
import { isMobile } from 'utilities/browser';

class ImportantMessageBox extends React.Component {
    constructor(props) {
        super(props);
        this.focusRef = React.createRef();
    }

    componentDidMount() {
        const { isFocus } = this.props;
        if (isFocus) {
            this.focusRef.current.scrollIntoView();
            isMobile() && window.scrollBy(0, -100);
        }
    }

    render() {
        const { color, title, message, icon } = this.props;

        return (
            <div ref={this.focusRef} className={`message-box ${color}`}>
                <i className={`icons icons--icon-${icon}`}></i>
                <div>
                    <p className="font-heading4">{formatText(title)}</p>
                    <p className="font-paragraph2">
                        <FormattedText value={message} />
                    </p>
                </div>
            </div>
        );
    }
}

ImportantMessageBox.propTypes = {
    title: PropTypes.string,
    message: PropTypes.string,
    color: PropTypes.string,
    icon: PropTypes.string,
    isFocus: PropTypes.bool,
};

ImportantMessageBox.defaultProps = {
    title: 'hightLightedText-important',
    message: '',
    icon: 'alert-red',
    color: 'red-box',
    isFocus: false,
};

export default ImportantMessageBox;
